// LOD Tiers definition - 8 Granular Steps for smoother transition
export const LOD_LEVELS = [
	{ count: 1000, distance: 6.0, label: '1K' },
	{ count: 5000, distance: 4.5, label: '5K' },
	{ count: 20000, distance: 3.5, label: '20K' },
	{ count: 50000, distance: 2.8, label: '50K' },
	{ count: 100000, distance: 2.2, label: '100K' },
	{ count: 250000, distance: 1.8, label: '250K' },
	{ count: 500000, distance: 1.5, label: '500K' },
	{ count: 1000000, distance: 1.2, label: '1M' }
]


export function getCountForTier(tier: number) {
	return LOD_LEVELS[tier]?.count || 1000
}
